import { useBreakpoint as useSkapaBreakpoint } from '@ingka/viewport-hooks';
import { UserDevice } from '../enums/UserDevice';
/**
 * A custom hook for breakpoints.
 * @returns An object containing if the screen size is of a desktop- or mobile size.
 */
export const useBreakpoint = () => {
    const breakpoint = useSkapaBreakpoint('sm', 'md', 'lg', 'xl');
    const isDesktop = breakpoint === 'lg' || breakpoint === 'xl';
    const isMobile = breakpoint === 'sm';
    const isTablet = breakpoint === 'md';
    const device = (isDesktop && UserDevice.DESKTOP) || (isMobile && UserDevice.MOBILE) || UserDevice.TABLET;
    return { isDesktop, isMobile, isTablet, device };
};
